import { render } from "./XMenuIcon.vue?vue&type=template&id=16ea627a&scoped=true"
import script from "./XMenuIcon.vue?vue&type=script&lang=js"
export * from "./XMenuIcon.vue?vue&type=script&lang=js"

import "./XMenuIcon.vue?vue&type=style&index=0&id=16ea627a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ea627a"]])

export default __exports__